import type { ReactNode } from "react";
import { createContext } from "react";

import { useNonNullableContext } from "app/common";

import type { AppsFlowStrategy } from "./AppsFlowContext.types";

const AppsFlowContext = createContext<AppsFlowStrategy | null>(null);
AppsFlowContext.displayName = "AppsFlowContext";

type AppsFlowProviderProps = {
    value: AppsFlowStrategy;
    children: ReactNode;
};

export const AppsFlowProvider = ({ value, children }: AppsFlowProviderProps) => {
    return <AppsFlowContext.Provider value={value}>{children}</AppsFlowContext.Provider>;
};

export const useAppsFlowStrategy = (): AppsFlowStrategy => useNonNullableContext(AppsFlowContext);
